<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div [config]="preloaderService.getLoadingConfig(loaderKey)" [suiIsLoading]="loaderKey" class="preloader-wrapper">
    <div class="siklu-mat-dialog-title" matDialogTitle>
        <h4>{{ 'preferences.title' | translate }}</h4>
        <button matDialogClose windeClose>
            <sui-svg-icon icon="cross" />
        </button>
    </div>
    <div *ngIf="preferences" class="siklu-mat-dialog-body" matDialogContent>
        <div class="row">
            <div class="control col-12">
                <div class="control-label">{{ 'preferences.popup.iconScale' | translate }}</div>
                <sui-number-component [config]="preferences.iconScale" class="sui-e2e-typeName"></sui-number-component>
            </div>
        </div>

        <div class="row">
            <div class="control col-12">
                <div class="control-label">{{ 'preferences.popup.textScale' | translate }}</div>
                <sui-number-component [config]="preferences.textScale" class="sui-e2e-typeName"></sui-number-component>
            </div>
        </div>

        <div class="row">
            <div class="control col-12">
                <div class="control-label">{{ 'preferences.popup.ptmpLinkLineOpacity' | translate }}</div>
                <sui-number-component [config]="preferences.ptmpLinkLineOpacity" class="sui-e2e-typeName"></sui-number-component>
            </div>
        </div>

        <div class="row">
            <div class="control col-12">
                <div class="control-label">{{ 'preferences.popup.ptpLinkLineOpacity' | translate }}</div>
                <sui-number-component [config]="preferences.ptpLinkLineOpacity" class="sui-e2e-typeName"></sui-number-component>
            </div>
        </div>

        <div class="row">
            <div class="control col-12">
                <div class="control-label">{{ 'preferences.popup.sectorAreaOpacity' | translate }}</div>
                <sui-number-component [config]="preferences.sectorAreaOpacity" class="sui-e2e-typeName"></sui-number-component>
            </div>
        </div>

        <div class="row">
            <div class="control col-12">
                <div class="control-label">{{ 'preferences.popup.wiredLinkLineOpacity' | translate }}</div>
                <sui-number-component [config]="preferences.wiredLinkLineOpacity" class="sui-e2e-typeName"></sui-number-component>
            </div>
        </div>

        <div class="row">
            <div class="control col-12">
                <div class="control-label">{{ 'preferences.popup.sectorsLineOpacity' | translate }}</div>
                <sui-number-component [config]="preferences.sectorsLineOpacity" class="sui-e2e-typeName"></sui-number-component>
            </div>
        </div>
    </div>
    <div class="siklu-mat-dialog-footer" matDialogActions>
        <button matDialogClose windeTransparent>
            <sui-svg-icon icon="cross" />
            {{ 'entity.action.cancel' | translate }}
        </button>
        <button (click)="save()" windeGreen>
            <sui-svg-icon icon="save" />
            {{ 'entity.action.accept' | translate }}
        </button>
    </div>
</div>
